import { Card, Form, Button, Row, Col } from 'react-bootstrap';
import { useState } from 'react';

export interface CorregedoriaFilterOptions {
  defensorId?: number;
  defensoriaId?: number;
  mes?: string;
  ano?: number;
  tipo?: 'civil' | 'criminal';
  /** true = só aguardando aval; false = todos (inclui já avaliados) */
  apenasAguardando?: boolean;
  /** Status para o select: todos | nao_aprovados | aprovados */
  statusFiltro?: 'todos' | 'nao_aprovados' | 'aprovados';
}

interface RelatoriosCorregedoriaFilterProps {
  onFilterChange: (filters: CorregedoriaFilterOptions) => void;
}

export default function RelatoriosCorregedoriaFilter({
  onFilterChange,
}: RelatoriosCorregedoriaFilterProps) {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [mes, setMes] = useState<string>('');
  const [ano, setAno] = useState<number>(currentYear);
  const [tipo, setTipo] = useState<string>('');
  const [statusFiltro, setStatusFiltro] = useState<string>('todos');

  const handleFilterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const filters: CorregedoriaFilterOptions = {};
    if (mes) filters.mes = mes;
    if (ano) filters.ano = ano;
    if (tipo) filters.tipo = tipo as 'civil' | 'criminal';
    filters.statusFiltro = (statusFiltro || 'todos') as 'todos' | 'nao_aprovados' | 'aprovados';
    filters.apenasAguardando = statusFiltro === 'nao_aprovados';
    onFilterChange(filters);
  };

  const handleClearFilters = () => {
    setMes('');
    setAno(currentYear);
    setTipo('');
    setStatusFiltro('todos');
    onFilterChange({
      statusFiltro: 'todos',
      apenasAguardando: false,
      ano: currentYear,
    });
  };

  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

  const meses = [
    { value: '01', label: 'Janeiro' },
    { value: '02', label: 'Fevereiro' },
    { value: '03', label: 'Março' },
    { value: '04', label: 'Abril' },
    { value: '05', label: 'Maio' },
    { value: '06', label: 'Junho' },
    { value: '07', label: 'Julho' },
    { value: '08', label: 'Agosto' },
    { value: '09', label: 'Setembro' },
    { value: '10', label: 'Outubro' },
    { value: '11', label: 'Novembro' },
    { value: '12', label: 'Dezembro' },
  ];

  return (
    <Card className="mb-4 shadow-sm">
      <Card.Header className="bg-light">
        <h5 className="mb-0">Filtros</h5>
      </Card.Header>
      <Card.Body>
        <Form onSubmit={handleFilterSubmit}>
          <Row className="align-items-end">
            <Col md={2}>
              <Form.Group className="mb-3">
                <Form.Label>Mês</Form.Label>
                <Form.Select value={mes} onChange={(e) => setMes(e.target.value)}>
                  <option value="">Todos</option>
                  {meses.map((m) => (
                    <option key={m.value} value={m.value}>
                      {m.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group className="mb-3">
                <Form.Label>Ano</Form.Label>
                <Form.Select value={ano} onChange={(e) => setAno(parseInt(e.target.value))}>
                  {years.map((y) => (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group className="mb-3">
                <Form.Label>Tipo</Form.Label>
                <Form.Select value={tipo} onChange={(e) => setTipo(e.target.value)}>
                  <option value="">Todos</option>
                  <option value="civil">Cível</option>
                  <option value="criminal">Criminal</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={statusFiltro}
                  onChange={(e) => setStatusFiltro(e.target.value)}
                >
                  <option value="todos">Todos</option>
                  <option value="nao_aprovados">Não aprovados</option>
                  <option value="aprovados">Aprovados</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3 d-flex align-items-end gap-2">
                <Button type="submit" variant="primary">
                  Filtrar
                </Button>
                <Button type="button" variant="outline-secondary" onClick={handleClearFilters}>
                  Limpar
                </Button>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
}
